import React, { useCallback, useRef, useState } from 'react'
import useSliderMethods from '../../Hooks/useSliderMethods'
import { Transition } from 'react-transition-group'
import BackgroundImage from '../../wp-adons/BackgroundImage'
import PreviousButton from '../../PageComponents/PreviousButton'
import NextButton from '../../PageComponents/NextButton'
import { setMargin, setPadding } from '../../utilities'
export default function IndexComponent ({
  gallery,
  margin_selection,
  padding_selection,
  ...props
}) {
  const [position, setPosition] = useState('left')
  const pageStyles = {
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  const nodeRef = useRef(null)
  const { setTimer, removeTimer, previousImage, nextImage, currentSlide } =
    useSliderMethods({
      loopTime: 10000,
      loop: gallery
    })
  const nextImageHandel = useCallback(
    e => {
      setPosition('left')
      nextImage()
    },
    [setPosition, nextImage]
  )
  const previousImageHandel = useCallback(
    e => {
      setPosition('right')
      previousImage()
    },
    [setPosition, previousImage]
  )
  return (
    <div
      style={{ ...pageStyles }}
      className='flex flex-col w-full m-auto max-w-sitemax h-svh max-h-[650px] items-center justify-center relative overflow-hidden z-10'
      onMouseEnter={removeTimer}
      onMouseLeave={setTimer}
      {...props}
    >
      <PreviousButton onClick={previousImageHandel} />

      <div className='grid grid-cols-4 w-full m-auto h-svh max-h-svh relative overflow-hidden'>
        <div className='col-span-4 lg:col-span-2 h-full relative'>
          {gallery?.map((post, index) => (
            <Transition
              in={index === currentSlide}
              nodeRef={nodeRef}
              timeout={1000}
              key={index}
            >
              {state => (
                <div
                  className={`gallery gallery-${state} w-full flex flex-col h-full absolute overflow-hidden justify-center items-center gap-6`}
                  ref={nodeRef}
                >
                  {post?.acf?.background_image && (
                    <BackgroundImage
                      background_image={post.acf?.background_image}
                    />
                  )}
                </div>
              )}
            </Transition>
          ))}
        </div>
        <div className='col-span-4 lg:col-span-2 h-full bg-transparent relative Z-0'>
          {gallery?.map((post, index) => (
            <Transition
              in={index === currentSlide}
              nodeRef={nodeRef}
              timeout={1000}
              key={index}
            >
              {state => (
                <div
                  className={`slider slider-${state} ${position} w-full h-2/3 lg:h-full flex flex-col justify-center items-center gap-6 absolute z-10 `}
                  ref={nodeRef}
                >
                  <div className='flex flex-col justify-center items-center p-8 relative h-full  '>
                    {post?.acf?.name_of_business && (
                      <p className='text-header4 relative z-10 text-color_light font-font-text_accent text-center  mb-4 uppercase'>
                        {post?.acf?.name_of_business}
                      </p>
                    )}
                    {post?.acf?.testimony && (
                      <div
                        className='text-header4 z-0  text-color_readable bg-color_light  p-4  text-center font-text_readable rounded-lg right-10 max-w-md '
                        dangerouslySetInnerHTML={{
                          __html: post?.acf?.testimony
                        }}
                      />
                    )}
                    {post?.acf?.name && (
                      <p className='text-header3 relative z-10 text-color_light text-center font-text_highlight mb-4 uppercase'>
                        {post?.acf?.name}
                      </p>
                    )}
                    {post?.acf?.profession && (
                      <p className='text-header3 relative z-10 text-color_light text-center font-text_highlight mb-4 uppercase'>
                        {post?.acf?.profession}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </Transition>
          ))}
        </div>
      </div>

      <NextButton onClick={nextImageHandel} />
    </div>
  )
}

// <div className='flex flex-col lg:flex-row w-full m-auto h-svh max-h-svh items-center justify-center relative overflow-hidden'>
//       <div className='flex-[70%] h-1/2 lg:h-full bg-black w-full max-w-[70%] flex'></div>
//       <div className='flex-[30%] h-1/2 lg:h-full bg-white w-full max-w-[30%] flex'></div>
//     </div>
